module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/wow-slider/wow-bounce-in-up/wow-bounce-in-up.component.scss
// module id = ./src/app/features/wow-slider/wow-bounce-in-up/wow-bounce-in-up.component.scss
// module chunks = main